import { jsx as _jsx } from "react/jsx-runtime";
import { SignIn } from "@clerk/clerk-react";
import Center from "../components/Center";
const SignInPage = () => {
    return (_jsx(Center, { children: _jsx(SignIn, { path: "/sign-in", routing: "path", signUpUrl: "/sign-up" }) }));
};
export default SignInPage;
